import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const LanguageDetector = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const { i18n } = useTranslation();

  useEffect(() => {
    const path = location.pathname;
    let detectedLanguage = 'pt'; // default

    // First priority: URL path (for shared links with language prefixes)
    if (path.startsWith('/en')) {
      detectedLanguage = 'en';
    } else if (path.startsWith('/es')) {
      detectedLanguage = 'es';
    } else {
      // Second priority: Check localStorage for saved preference
      const savedLanguage = localStorage.getItem('i18nextLng');
      if (savedLanguage && ['pt', 'en', 'es'].includes(savedLanguage)) {
        detectedLanguage = savedLanguage;
      }
    }

    // Normalize i18n.language to handle variants like 'en-US' -> 'en'
    const currentLang = i18n.language?.split('-')[0] || 'pt';

    if (currentLang !== detectedLanguage) {
      i18n.changeLanguage(detectedLanguage);
    }
  }, [location.pathname, i18n]);

  return <>{children}</>;
};
